
import React from "react";
import { Card } from 'react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import { getVar,ProductTitle } from './Helper';
import styled from 'styled-components'

const StyledLink = styled(Link)`
    position:relative;
    margin-bottom: 15px;
    /* max-width:214px; */
    display: block;
`;
const Image = styled.div`
    height:120px;
    width:100%;
    background-position-x: center !important;
    background-position-y: center !important;
    background-size: cover !important;
    background-image : url(${props => props.imgSrc});
    background-repeat: no-repeat;
`; 

function PlotThumb( {item} ){   

    const baseUrl = getVar().baseUrl; 
    let history = useHistory();   
    return (    
        <StyledLink className="featured-product"  key={item.id}  to={`${history.location.pathname}?plot=${item.id}`}>
            <Card>
                <Image imgSrc={baseUrl + item.imageSrc} />
                <ProductTitle>{item.name}</ProductTitle>
            </Card>
        </StyledLink>        
        )
}

export default PlotThumb;